import React, { FunctionComponent, useEffect, useState } from "react";
import Popup from "reactjs-popup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMultiply, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import apiCalls from "../PowerShadesAPIFunctions";

type OrderEmailsProps = {
	quoteId: number;
	quoteType: string;
};

const OrderEmails: FunctionComponent<OrderEmailsProps> = ({ quoteId, quoteType }) => {
	const [emails, setEmails] = useState<string[]>([]);
	const [open, setOpen] = useState(false);

	useEffect(() => {
		// Fetch the order emails from the API
		apiCalls.getOrderEmails(quoteId).then((response) => {
			if (response.data && Array.isArray(response.data.emails)) {
				const dataEmails = response.data.emails.map((e) => e.email_address);

				setEmails(dataEmails);
			} else {
				console.error("Invalid response format for order emails");
			}
		}).catch((error) => {
			console.error("Error fetching order emails:", error);
		});
	}, [quoteId]);

	const onClose = () => setOpen(false);

	return (
		<>
			<Popup
				open={open}
				onClose={onClose}
				modal
				closeOnDocumentClick
				className="mobile-modal"
				contentStyle={{ width: "80%", maxWidth: "600px", padding: "20px" }}
			>
				<div className='order-emails-header d-flex align-items-start position-relative'>
					<FontAwesomeIcon
						icon={faMultiply}
						className="close-icon link-secondary"
						onClick={onClose}
						style={{ marginRight: '1em', flex: '0 0 auto' }}
						cursor='pointer'
					/>
					<h2 className="flex-grow-1 text-center m-0">Order Emails</h2>
				</div>
				<div className="order-emails-content">
					{emails.length > 0 ? (
						<div className="email-list">
							{emails.map((email) => (
								<div
									key={email}
									className="email-item"
									style={{
										padding: '10px 15px',
										margin: '8px 0',
										backgroundColor: '#f8f9fa',
										borderRadius: '4px',
										border: '1px solid #dee2e6',
										fontSize: '14px',
										color: '#495057',
										display: 'flex',
										alignItems: 'center'
									}}
								>
									<FontAwesomeIcon
										icon={faEnvelope}
										style={{
											marginRight: '10px',
											color: '#6c757d'
										}}
									/>
									{email}
								</div>
							))}
						</div>
					) : (
						<p>No order emails found.</p>
					)}
				</div>
				<div className="order-emails-footer">
					<button type="button" onClick={onClose} className={`btn btn-${quoteType}`}>Close</button>
				</div>
			</Popup>
			<button type="button" onClick={() => setOpen(true)} className={`btn btn-${quoteType}`}>
				View Order Emails
			</button>
		</>
	);
};

export default OrderEmails;
